import { useState } from "react";
import { IDoctor } from "../../interfaces/api";
import MedicalGroupTile from "../../shared/ModalComponent/MedicalGroupTile";

const SelectMedicalGroup = ({
  doctorInfo,
  AddDocDrug,
  goToSearch,
}: {
  doctorInfo: IDoctor;
  AddDocDrug: (data: any) => void;
  goToSearch: () => void;
}) => {
  const [acceptNewPatients, setAcceptNewPatients] = useState<boolean>(false);

  const filteredGroups = doctorInfo.ahRecords.filter((record) =>
    acceptNewPatients
      ? record.addresses.some(
          (address) => address.isAcceptingNewPatients === "Yes"
        )
      : true
  );

  const allGroups = filteredGroups.flatMap((record) => record.medGrpNetwork);

  return (
    <>
      <div
        className="hide-for-small-only text-left"
        style={{
          padding: "32px 70px 32px 70px",
        }}
      >
        <h3 className="color-secondary text-uppercase">
          Select A Medical Group
        </h3>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/vector.svg"
          }
          alt="Vector"
          style={{ marginRight: "8px" }}
        />
        <div
          className="flex-container align-middle"
          style={{ padding: "24px 0px", display: "flex" }}
        >
          <img
            src={
              (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
              "/DoctorItem.png"
            }
            alt="Vector"
            width={50}
            height={55}
          />

          <div
            className="flex-container"
            style={{ flexDirection: "column", paddingLeft: 16 }}
          >
            <h2 style={{ fontWeight: 600, fontSize: "30px" }}>
              {doctorInfo.nppes.firstName} {doctorInfo.nppes.lastName},{" "}
              {doctorInfo.nppes.suffix}
            </h2>
            <div style={{ fontSize: "18px" }}>
              {doctorInfo.specialities[0].desc}
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              padding: "39px 0px 10px 4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <label
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <input
                type="checkbox"
                checked={acceptNewPatients}
                onChange={() => setAcceptNewPatients(!acceptNewPatients)}
                style={{ width: 18, height: 18 }}
              />
              <div style={{ paddingLeft: "8px" }}>Accepting new patients</div>
            </label>
            <div>Number of Medical Groups: {doctorInfo.ahRecords.length}</div>
          </div>
          <div
            className="grid-x"
            style={{ overflowY: "auto", maxHeight: "400px" }}
          >
            {filteredGroups.map((element, index) => (
              <MedicalGroupTile
                data={element}
                doctorInfo={doctorInfo}
                key={index}
                AddDocDrug={AddDocDrug}
                goToSearch={goToSearch}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className="show-for-small-only text-left"
        style={{
          padding: "20px",
        }}
      >
        <h3 className="color-secondary text-uppercase">
          Select A Medical Group
        </h3>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/vector.svg"
          }
          alt="Vector"
          style={{ marginRight: "8px" }}
        />
        <div
          className="flex-container align-middle"
          style={{ padding: "24px 0px", display: "flex" }}
        >
          <img
            src={
              (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
              "/DoctorItem.png"
            }
            alt="Vector"
            width={50}
            height={55}
          />

          <div
            className="flex-container"
            style={{ flexDirection: "column", paddingLeft: 16 }}
          >
            <h2 style={{ fontWeight: 600, fontSize: "30px" }}>
              {doctorInfo.nppes.firstName} {doctorInfo.nppes.lastName},{" "}
              {doctorInfo.nppes.suffix}
            </h2>
            <div style={{ fontSize: "18px" }}>
              {doctorInfo.specialities[0].desc}
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              padding: "20px 0px 10px 4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <label
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <input
                type="checkbox"
                checked={acceptNewPatients}
                onChange={() => setAcceptNewPatients(!acceptNewPatients)}
                style={{ width: 18, height: 18 }}
              />
              <div style={{ paddingLeft: "8px" }}>Accepting new patients</div>
            </label>
          </div>
          <div>Number of Medical Groups: {allGroups.length}</div>

          <div
            className="grid-x"
            style={{ overflowY: "auto", maxHeight: "400px" }}
          >
            {acceptNewPatients
              ? doctorInfo.ahRecords
                  .filter((record) =>
                    record.addresses.some(
                      (address) => address.isAcceptingNewPatients === "Yes"
                    )
                  )
                  .map((element, index) => (
                    <MedicalGroupTile
                      data={element}
                      doctorInfo={doctorInfo}
                      key={index}
                      AddDocDrug={AddDocDrug}
                      goToSearch={goToSearch}
                    />
                  ))
              : doctorInfo.ahRecords.map((element, index) => (
                  <MedicalGroupTile
                    data={element}
                    doctorInfo={doctorInfo}
                    key={index}
                    AddDocDrug={AddDocDrug}
                    goToSearch={goToSearch}
                  />
                ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectMedicalGroup;
